import { Box, Divider, Typography, useMediaQuery } from "@mui/material"; // import MUI components for layout and text styling
import React from "react";
import { Link, Outlet } from "react-router-dom";
import SideMenu from "../../components/SideMenu";
import { drawerWidth } from "../../utils/constants";
import theme from "../../utils/theme";

export default function RootLayout() {
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box>
      <SideMenu />
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Outlet />

        <Box
          sx={{
            padding: 2,
            marginLeft: isMobile ? 0 : `${drawerWidth}px`,
            textAlign: "right",
          }}
        >
          <Divider sx={{ my: 2 }} />

          <Typography variant="body2" color="textSecondary">
            Developed by{" "}
            <Link to="https://orbit.et" target="_blank">
              Orbit Technology Solution
            </Link>
            .
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
